import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormService } from 'src/app/form/form.service';
import { FormTable } from 'src/app/form/model/form.model';
import { NotificationType } from 'src/app/notifications/notification.model';
import { NotificationService } from 'src/app/notifications/notification.service';
import { notify } from '../../../utils/function/notification.util';

@Component({
  selector: 'remove-form-popup',
  templateUrl: './remove-form-popup.component.html',
  styleUrl: './remove-form-popup.component.scss',
  standalone: false
})
export class RemoveFormPopupComponent implements OnInit {

  @Input() isModalVisible = false;

  @Input()
  set formObject(formObject: FormTable | undefined) {
    if (formObject) {
      this._formObject = formObject;
      this._formUUID = formObject.uuid;
    }
  }

  @Output() stateVisibleModal = new EventEmitter<string>();

  _formObject?: FormTable;
  _formUUID = '';

  form!: FormGroup;
  copied = false;

  private destroyRef = inject(DestroyRef);

  constructor(
    private fb: NonNullableFormBuilder,
    private formService: FormService,
    private notificationService: NotificationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.initializeFormGroup();
  }

  private initializeFormGroup(): void {
    this.form = this.fb.group({
      name: ['', Validators.required]
    });
  }

  onClickDelete(deletion: boolean): void {
    if (deletion && this.onValidateEnable() && this._formObject) {
      this.formService.deleteToForm(this._formObject.uuid)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            notify(this.notificationService, NotificationType.SUCCESS, 'remove-form-popup.notification.success');
            this.closeAndEmit(this._formUUID);
          },
          error: () => {
            notify(this.notificationService, NotificationType.ERROR, 'remove-form-popup.notification.error');
          }
        });
      return;
    }
    this.closeAndEmit('');
  }

  onValidateEnable(): boolean {
    return !!this._formObject && this._formObject.name === this.form.get('name')?.value;
  }

  copyName(): void {
    if (!this._formObject) {
      return;
    }
    navigator.clipboard.writeText(this._formObject.name).then(() => {
      this.copied = true;
      setTimeout(() => this.copied = false, 1000);
    });
  }

  popupClose(): void {
    this.closeAndEmit('');
  }

  private closeAndEmit(uuid: string): void {
    this.isModalVisible = false;
    this.form.reset();
    this.stateVisibleModal.emit(uuid);
  }
}
